// extracted by mini-css-extract-plugin
export default {"body":"Loader_body__Mgr3E","body_live":"Loader_body_live__qJ6YW","loader":"Loader_loader__BTtXn","spin":"Loader_spin__k4ert"};